import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Button, Card, Badge, Empty, Spinner } from '../ui.jsx';

const STATUS = {
  new: ['جديد', 'info'],
  in_progress: ['قيد المعالجة', 'warn'],
  done: ['منجز', 'ok'],
  rejected: ['مرفوض', 'bad'],
};
const PLAT = { facebook: ['فيسبوك', 'fb'], google: ['قوقل', 'gg'] };

export default function Requests() {
  const [data, setData] = useState(null);
  const [stats, setStats] = useState(null);
  const [filters, setFilters] = useState({ status: '', platform: '', q: '' });

  useEffect(() => {
    const t = setTimeout(() => {
      const p = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => v && p.set(k, v));
      api('/api/requests?' + p)
        .then((d) => setData(d.requests))
        .catch(() => setData([]));
      api('/api/requests/stats').then((d) => setStats(d.stats));
    }, 250);
    return () => clearTimeout(t);
  }, [filters]);

  async function setStatus(id, status) {
    await api(`/api/requests/${id}`, { method: 'PATCH', body: { status } });
    api('/api/requests/stats').then((d) => setStats(d.stats));
  }

  async function remove(id) {
    if (!confirm('حذف هذا الطلب؟')) return;
    await api(`/api/requests/${id}`, { method: 'DELETE' });
    setData((d) => d.filter((r) => r.id !== id));
  }

  const s = stats;
  return (
    <>
      {s && (
        <div className="stats">
          {[
            ['الإجمالي', s.total, 'total'],
            ['جديد', s.byStatus.new || 0, 'info'],
            ['قيد المعالجة', s.byStatus.in_progress || 0, 'warn'],
            ['منجز', s.byStatus.done || 0, 'ok'],
            ['فيسبوك', s.byPlatform.facebook || 0, 'fb'],
            ['قوقل', s.byPlatform.google || 0, 'gg'],
          ].map(([l, v, tone]) => (
            <div key={l} className="stat">
              <span>{l}</span>
              <b className={`t-${tone}`}>{v}</b>
            </div>
          ))}
        </div>
      )}

      <Card title="الطلبات">
        <div className="filters">
          <select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="">كل الحالات</option>
            {Object.entries(STATUS).map(([k, [l]]) => (
              <option key={k} value={k}>{l}</option>
            ))}
          </select>
          <select
            value={filters.platform}
            onChange={(e) => setFilters({ ...filters, platform: e.target.value })}
          >
            <option value="">كل المنصات</option>
            {Object.entries(PLAT).map(([k, [l]]) => (
              <option key={k} value={k}>{l}</option>
            ))}
          </select>
          <input
            value={filters.q}
            onChange={(e) => setFilters({ ...filters, q: e.target.value })}
            placeholder="بحث في نص البلاغ أو الرابط..."
          />
          <Button
            onClick={() => setFilters({ status: '', platform: '', q: '' })}
          >
            إعادة تعيين
          </Button>
        </div>

        {!data ? (
          <Spinner />
        ) : !data.length ? (
          <Empty>لا توجد طلبات مطابقة</Empty>
        ) : (
          data.map((r) => (
            <article key={r.id} className="req">
              <div className="req-top">
                <span className="req-id">#{r.id}</span>
                <Badge tone={PLAT[r.platform]?.[1]}>{PLAT[r.platform]?.[0] || r.platform}</Badge>
                <Badge tone={STATUS[r.status]?.[1]}>{STATUS[r.status]?.[0] || r.status}</Badge>
                <a className="link" href={r.targetUrl} target="_blank" rel="noreferrer">
                  {r.targetTitle}
                </a>
                <time className="muted small">{new Date(r.createdAt).toLocaleString('ar')}</time>
              </div>

              <p className="req-body">{r.message}</p>

              <div className="req-foot">
                <span className="muted small">
                  👤 {r.reporterName}
                  {r.reporterContact ? ` — ${r.reporterContact}` : ''}
                </span>
                <div className="actions">
                  <select
                    className="mini-select"
                    value={r.status}
                    onChange={(e) => setStatus(r.id, e.target.value)}
                  >
                    {Object.entries(STATUS).map(([k, [l]]) => (
                      <option key={k} value={k}>{l}</option>
                    ))}
                  </select>
                  <Button size="sm" variant="danger" onClick={() => remove(r.id)}>
                    حذف
                  </Button>
                </div>
              </div>
            </article>
          ))
        )}
      </Card>
    </>
  );
}